<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      :href="href"
      class="rail-item"
      :class="{ 'is-active': isActive || isChildMenuActive }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <span class="rail-ico">
        <svg viewBox="0 0 24 24">
          <path v-for="(d, i) in iconPaths" :key="i" :d="d" />
        </svg>
      </span>
      <span class="rail-label">{{ $t(`SIDEBAR.${name}`) }}</span>
      <span v-if="count" class="rail-badge">{{ count }}</span>
    </a>
  </router-link>
</template>
<script>
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

// Ícones do rail (traço fino), mapeados por chave do menu — iguais ao protótipo
const RAIL_ICONS = {
  dashboard: [
    'M3 3h7v9H3zM14 3h7v5h-7zM14 12h7v9h-7zM3 16h7v5H3z',
  ],
  conversations: [
    'M21 11.5a8.38 8.38 0 0 1-9 8.4 8.5 8.5 0 0 1-3.9-.9L3 20l1-3.1A8.38 8.38 0 0 1 12 3a8.5 8.5 0 0 1 9 8.5Z',
  ],
  contacts: [
    'M6 3h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z',
    'M11 12.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z',
    'M7.5 16a3.5 3.5 0 0 1 7 0',
  ],
  crm: ['M4 4h16l-6 7.5V18l-4 2v-8.5L4 4Z', 'M8 8h8'],
  smartsurvey: [
    'M5 3h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z',
    'M9 3.5A1.5 1.5 0 0 1 10.5 2h3A1.5 1.5 0 0 1 15 3.5V5H9V3.5Z',
    'm8.5 13 2 2 4-4',
  ],
  typebot: [
    'M8 8h8a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4Z',
    'M12 8V5',
    'M12 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
    'M9 14h.01M15 14h.01M2 13v3M22 13v3',
  ],
  campaigns: [
    'm3 11 15-6v14l-15-6v-2Z',
    'M18 8a3 3 0 0 1 0 6M7 13v4a2 2 0 0 0 3.9.6',
  ],
  campaigns_flow: [
    'M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM18 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
    'M8 6h6a2 2 0 0 1 2 2M8 18h6a2 2 0 0 0 2-2M6 8v8',
  ],
  wise: [
    'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9',
    'M13.7 21a2 2 0 0 1-3.4 0',
  ],
  helpcenter: [
    'M2 5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H2ZM22 5a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h5Z',
  ],
  dashboard_embed: [
    'M4 4h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z',
    'M3 9h18M6.5 6.5h.01M9 6.5h.01',
  ],
  reports: ['M3 3v18h18', 'M8 17v-5M13 17V8M18 17v-8'],
};

export default {
  mixins: [globalConfigMixin],
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    menuKey: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconPaths() {
      return RAIL_ICONS[this.menuKey] || RAIL_ICONS.dashboard;
    },
  },
};
</script>
<style lang="scss" scoped>
// Item do rail no padrão do protótipo: ícone em cima + label embaixo
.rail-item {
  width: 6.4rem;
  min-height: 5.4rem;
  padding: 0.8rem 0.3rem 0.6rem;
  margin: 0;
  border: 0;
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  color: #9fb4bf;
  position: relative;
  cursor: pointer;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    color: #d7e6ec;
  }

  // Ativo: destaque + barra ciana à esquerda
  &.is-active {
    background: rgba(255, 255, 255, 0.11);
    color: #fff;

    &::before {
      content: '';
      position: absolute;
      left: -0.6rem;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 2.6rem;
      background: var(--color-woot);
      border-radius: 3px;
    }
  }
}

.fi {
  font-size: 17px !important;
  color: var(--w-50);
}
.rail-ico {
  width: 2.2rem;
  height: 2.2rem;
  display: grid;
  place-items: center;
  flex: none;

  svg {
    width: 2.2rem;
    height: 2.2rem;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

.rail-label {
  font-size: 0.9rem;
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.1px;
  line-height: 1.15;
  text-align: center;
  width: 100%;
  // permite até 2 linhas para labels longos (ex.: Central de Ajuda)
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.rail-badge {
  position: absolute;
  top: 0.2rem;
  right: 0.6rem;
  background: var(--color-woot);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 8px;
  display: grid;
  place-items: center;
  padding: 0 0.4rem;
}
</style>
